export default __webpack_public_path__ + "static/media/Boathouse.68ef989f.jpg";